import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import type { paths } from "./generated-api-types";

// Create the base fetch client and React Query client
export const $rawApi = createFetchClient<paths>({ baseUrl: "" });
export const $api = createClient($rawApi);
